import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Grid,
  Link,
  CircularProgress,
  Fade,
  Slide,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import WavingHandIcon from "@mui/icons-material/WavingHand";
import { useAuth } from "../../hooks/useAuth";
import { toast } from "react-toastify";
import Lottie from "lottie-react";
import loginAnimation from "../../assets/lottieanimations/login_screen.json";

// import { useNavigate } from "react-router-dom";

export default function GenerateOtp() {
  const location = useLocation();
  const auth = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); //start as false
  const [otp, setOtp] = useState("");
  const statePhone = location.state?.phone;
  const [phone, setPhone] = useState(
    statePhone || localStorage.getItem("otpPhone") || "",
  );

  useEffect(() => {
    if (statePhone) {
      localStorage.setItem("otpPhone", statePhone);
    }
  }, [statePhone]);

  const handleResendOtp = async () => {
    setLoading(true); //start loader when click on button
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/otp-generator/generateotp`,
        {
          otpSrc: phone,
          otpType: "LOGIN",
          otpFor: "Admin",
        },
        {
          headers: {
            version: "1.1.1",
          },
        },
      );

      console.log("generate OTP for:", phone);
      setTimeout(() => {
        if (response.data?.data?.includes("otp")) {
          toast.success(`OTP resent: ${response.data.data}`);
        } else {
          toast.error(response.data?.data || "Failed to resend OTP");
        }
        setLoading(false);
      }, 3000);
    } catch (error) {
      console.error("Resend OTP error:", error);
      setTimeout(() => {
        setLoading(false);
        toast.error("Resend OTP failed");
      }, 3000);
    }
  };

  const handleVerifyOtp = async () => {
    setLoading(true); //start loader when click on button

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/otp-generator/verifyOtp`,
        {
          otpSrc: phone,
          otpType: "LOGIN",
          otp: Number(otp),
          otpFor: "Admin",
        },
        {
          headers: {
            version: "1.1.1",
          },
        },
      );

      console.log("Verifying OTP for:", phone);

      if (response.data?.success) {
        const user = response.data?.success;
        const userEmail = response.data?.data?.user?.email;
        if (userEmail) {
          localStorage.setItem("userEmail", userEmail);
        }
        if (response.data?.data?.user) {
          localStorage.setItem(
            "user",
            JSON.stringify(response.data?.data?.user),
          );
          console.log("any user data", response.data?.data?.user);
          console.log(
            "any user permission",
            response.data?.data?.user?.userRole?.permissions,
          );
        }
        const isSubscriptionExpired = response.data?.data?.subscriptionExpired;
        const hasJewellerDocument = response.data?.data?.hasjewellerDocument;
        localStorage.setItem(
          "subscriptionExpired",
          isSubscriptionExpired ? "true" : "false",
        );
        localStorage.setItem(
          "hasjewellerDocument",
          hasJewellerDocument === false ? "false" : "true",
        );
        if (isSubscriptionExpired) {
          localStorage.setItem(
            "userPermissions",
            JSON.stringify({
              subscriptionList: {
                view: true,
                edit: true,
              },
            }),
          );
        } else if (response.data?.data?.user?.userRole?.permissions) {
          localStorage.setItem(
            "userPermissions",
            JSON.stringify(response.data?.data?.user?.userRole?.permissions),
          );
        } else {
          console.warn("User permissions not found in response");
        }

        toast.info(response.data.message);
        setTimeout(() => {
          const userPermissions =
            response.data?.data?.user?.userRole?.permissions || {};

          const requiredPermissions = [
            "instalaxmiPermission",
            "bookingTransaction",
            "bookingBullion",
            "bookingReport",
          ];
          const hasAllRequiredPermissions = requiredPermissions.every(
            (perm) => {
              return (
                userPermissions[perm]?.view || userPermissions[perm]?.create
              );
            },
          );
          const hasOnlyRequiredPermissions = Object.keys(userPermissions).every(
            (perm) => requiredPermissions.includes(perm),
          );

          auth.login(
            {
              username: phone,
              password: "password",
              rememberMe: "rememberMe",
              login: "admin",
            },
            (message) => toast.info(message),
            response,
          );
          const isSubscriptionExpired =
            response.data?.data?.subscriptionExpired;
          const hasJewellerDocument =
            response.data?.data?.hasjewellerDocument;

          if (isSubscriptionExpired) {
            console.log("Subscription expired, navigating to SubscriptionsPage");
            navigate("/SubscriptionsPage");
          } else if (hasJewellerDocument === false) {
            window.location.href = "/UploadJewellerDocument";
          } else if (hasAllRequiredPermissions && hasOnlyRequiredPermissions) {
            window.location.href = "/BookingBullionPage";
          } else {
            console.log("User has other permissions, navigating to Dashboard");
            window.location.href = "/dashboard";
          }

          setLoading(false);
        }, 100); //small delay to show loader
      } else {
        toast.error(response.data?.message || "OTP verification failed");
        setLoading(false);
      }
    } catch (error) {
      console.error("Verify OTP error:", error);
      toast.error("OTP verification failed");
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Fade in={true} timeout={800}>
        <Grid container sx={{ minHeight: "100vh" }}>
          {/* Left Part - Lottie Animation */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              background:
                "linear-gradient(135deg, #f8f9ff 0%, #e8ebff 50%, #f0f2ff 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: { xs: 3, sm: 4, md: 6 },
              position: "relative",
              order: { xs: 1, md: 1 },
            }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: { xs: 400, sm: 500, md: 600 },
                height: "auto",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Lottie
                animationData={loginAnimation}
                loop={true}
                style={{ width: "100%", height: "100%" }}
              />
            </Box>
          </Grid>

          {/* Right Part - OTP Form */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              background: "#ffffff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: { xs: 3, sm: 4, md: 6 },
              order: { xs: 2, md: 2 },
            }}
          >
            <Slide direction="left" in={true} timeout={600}>
              <Box
                sx={{
                  width: "100%",
                  maxWidth: { xs: "100%", sm: 600, md: 650 },
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  justifyContent: "center",
                }}
              >
                {/* Welcome Section */}
                <Box
                  sx={{
                    textAlign: "left",
                    mb: { xs: 4, sm: 5, md: 6 },
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      mb: 2,
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
                        fontWeight: 700,
                        color: "#1a1a1a",
                        lineHeight: 1.2,
                      }}
                    >
                      Welcome Back
                    </Typography>
                    <WavingHandIcon
                      sx={{
                        fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
                        color: "#7028DA",
                        animation: "wave 2s ease-in-out infinite",
                        "@keyframes wave": {
                          "0%, 100%": { transform: "rotate(0deg)" },
                          "25%": { transform: "rotate(20deg)" },
                          "75%": { transform: "rotate(-20deg)" },
                        },
                      }}
                    />
                  </Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: { xs: "1rem", sm: "1.2rem" },
                      fontWeight: 400,
                      color: "#666",
                      mb: 1,
                    }}
                  >
                    Enter your OTP to continue.
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: { xs: "0.9rem", sm: "1rem" },
                      color: "#999",
                    }}
                  >
                    We sent a one-time password to <b>{phone}</b>
                  </Typography>
                </Box>

                {/* OTP Form */}
                <Card
                  sx={{
                    width: "100%",
                    borderRadius: 3,
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                    background: "#ffffff",
                    border: "1px solid rgba(112, 40, 218, 0.1)",
                    transition: "all 0.3s ease",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <CardContent
                    sx={{
                      p: { xs: 4, sm: 5, md: 6 },
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {/* Header Section */}
                    <Box sx={{ mb: { xs: 4, sm: 5 }, textAlign: "left" }}>
                      <Typography
                        variant="h3"
                        sx={{
                          fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2rem" },
                          fontWeight: 600,
                          color: "#1a1a1a",
                          mb: 1,
                        }}
                      >
                        Verify OTP
                      </Typography>
                      <Box
                        component="span"
                        sx={{
                          display: "block",
                          width: "100px",
                          height: "4px",
                          background:
                            "linear-gradient(90deg, #7028DA 0%, #9E3ED7 100%)",
                          borderRadius: 2,
                          mt: 1.5,
                        }}
                      />
                    </Box>

                    <Box sx={{ mb: { xs: 4, sm: 5 } }}>
                      <TextField
                        label="OTP"
                        fullWidth
                        variant="outlined"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        inputMode="numeric"
                        autoComplete="one-time-code"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: 3,
                            backgroundColor: "#f8f9fa",
                            minHeight: "64px",
                            padding: "8px 16px",
                            fontSize: { xs: "1rem", sm: "1.1rem" },
                            transition: "all 0.3s ease",
                            "&:hover": {
                              backgroundColor: "#ffffff",
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#7028DA",
                                borderWidth: "2px",
                              },
                            },
                            "&.Mui-focused": {
                              backgroundColor: "#ffffff",
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#7028DA",
                                borderWidth: "2px",
                              },
                            },
                            "& input": {
                              padding: "12px 8px",
                              fontSize: { xs: "1rem", sm: "1.1rem" },
                              letterSpacing: "0.25em",
                            },
                          },
                          "& .MuiInputLabel-root": {
                            fontSize: { xs: "1rem", sm: "1.1rem" },
                            "&.Mui-focused": {
                              color: "#7028DA",
                              fontSize: { xs: "1.05rem", sm: "1.15rem" },
                            },
                          },
                        }}
                      />
                    </Box>

                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{ mb: { xs: 3, sm: 4 } }}
                    >
                      <Grid item>
                        <Link
                          component="button"
                          onClick={() => navigate("/login")}
                          underline="none"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            color: "#111",
                            fontWeight: 500,
                            fontSize: { xs: "0.95rem", sm: "1rem" },
                            background: "none",
                            border: "none",
                            padding: 0,
                            cursor: "pointer",
                          }}
                        >
                          <ArrowBackIcon fontSize="small" sx={{ mr: 0.5 }} />
                          Change Phone Number
                        </Link>
                      </Grid>
                      <Grid item>
                        <Link
                          component="button"
                          underline="none"
                          sx={{
                            background:
                              "linear-gradient(90deg, #7028DA 0%, #9E3ED7 100%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            fontWeight: 600,
                            fontSize: { xs: "0.95rem", sm: "1rem" },
                            backgroundColor: "transparent",
                            border: "none",
                            padding: 0,
                            cursor: "pointer",
                          }}
                          onClick={handleResendOtp}
                        >
                          Resend OTP
                        </Link>
                      </Grid>
                    </Grid>

                    <Button
                      variant="contained"
                      fullWidth
                      disabled={loading}
                      sx={{
                        background:
                          "linear-gradient(135deg, #7028DA 0%, #9E3ED7 100%)",
                        fontWeight: 600,
                        fontSize: { xs: "1.1rem", sm: "1.25rem", md: "1.3rem" },
                        py: { xs: 1.5, sm: 1.75, md: 2 },
                        textTransform: "none",
                        borderRadius: 3,
                        boxShadow: "0 4px 15px rgba(112, 40, 218, 0.4)",
                        transition: "all 0.3s ease",
                        position: "relative",
                        overflow: "hidden",
                        minHeight: { xs: "48px", sm: "52px" },
                        "&:hover": {
                          background:
                            "linear-gradient(135deg, #5a1fb8 0%, #8a2fc0 100%)",
                          boxShadow: "0 6px 20px rgba(112, 40, 218, 0.5)",
                          transform: "translateY(-2px)",
                        },
                        "&:active": {
                          transform: "translateY(0px)",
                        },
                      }}
                      onClick={handleVerifyOtp}
                    >
                      {loading ? (
                        <CircularProgress size={24} sx={{ color: "white" }} />
                      ) : (
                        "Verify & Login"
                      )}
                    </Button>
                  </CardContent>
                </Card>
              </Box>
            </Slide>
          </Grid>
        </Grid>
      </Fade>
    </Box>
  );
}
